import http from "../services/http-common";

export const params = {
	namespaced: true,
	state: {
		params: {
			eventTypes: [],
			projects: [],
			mainSlides: [],
		},
	},
	actions: {
		async getParams({ commit }) {
			try {
				let res = await http.get("/params");
				commit("params/UPDATE_PARAMS", res.data, { root: true });
			} catch (error) {
				console.log(error);
			}
		},
		async getSlides({ commit }) {
			try {
				let res = await http.get("/events/slides");
				commit("params/UPDATE_MAIN_SLIDER", res.data, { root: true });
			} catch (error) {
				console.log(error);
			}
		},
	},
	mutations: {
		UPDATE_PARAMS(state, data) {
			state.params.eventTypes = data.eventTypes;
			state.params.projects = data.projects;
		},
		UPDATE_MAIN_SLIDER(state, data) {
			state.params.mainSlides = data;
		},
	},
	getters: {
		GET_PARAMS(state) {
			return state.params;
		},
		GET_EVENT_TYPES: (state) => {
			return state.params.eventTypes;
		},
		GET_EVENT_TYPE: (state) => (id) => {
			return state.params.eventTypes.find((eventType) => eventType._id === id);
		},
		GET_PROJECTS: (state) => {
			return state.params.projects;
		},
		GET_PROJECT: (state) => (id) => {
			return state.params.projects.find((project) => project._id === id);
		},
		GET_MAIN_SLIDES: (state) => {
			return state.params.mainSlides;
		},
	},
};
